<template>
  <b-checkbox v-model="isTotal" />
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { FieldCalculationV2Config, FieldMapItem } from '@/types'

const props = {
  field: {
    type: Object as PropType<FieldMapItem | FieldCalculationV2Config>,
    required: true,
  },
}

@Component
export default class UpdateFieldMapTotal extends Vue.extend({ props }) {
  get isTotal () {
    return 'total' in this.field && this.field.total
  }

  set isTotal (isTotal) {
    if (isTotal) {
      this.$typedStore.visualisationApp.addTotalField(this.field.column)
    } else {
      this.$typedStore.visualisationApp.removeTotalField(this.field.column)
    }
  }
}

</script>
